import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, {
  providers: appConfig.providers,
});

// ionic start post-frontend blank --type=angular
// ionic serve --host 0.0.0.0 -p4200
// ionic cap sync --configuration=development
// ionic cap sync --configuration=production
// firebase deploy --only hosting

/*

do not use     "@capacitor/local-notifications": "^8.2.0",

in pages-auth.ts , I see that the htmls and scss have comments, I suppose that is genaration error or typo


Hello world        -> Latin script
Bonjour le monde   -> Latin script
नमस्ते दुनिया       -> Devanagari script
مرحبا بالعالم       -> Arabic script
こんにちは世界       -> Japanese scripts
Hello नमस्ते       -> Mixed: Latin + Devanagari, major: maybe Devanagari/Latin by count


Please do not remove unused code , do not remove commented code, do not remove redundant page r components. Do not add any truncate or 'delete' like in sql
please assume user will do the verification and no need to run npm build and gradlew command or android sync. Ask me any question if I am contradicting, please point out

Please focus mainly on UI that is HTML and scss , The idea is that backend will create the user and that part you can assume is done
for TS, do not make changes unless absolutely necessary and tell me before making changes 
Also keep the old profile/me and old signin

*
old: When A grants B Inner Circle, B IS now Inner Circle in A's account (the grant is effective).
 What it does NOT do is automatically make A Inner Circle in B's account — B must independently grant that.

 and more clear iw below
 
 When A grants B Inner Circle, B now can see A's Posts that are marked 'Inner Circle' in addition to Connection Posts and World.
 What it does NOT do is automatically make A in 'Inner Circle' of B's account — B must independently grant that.
*
 
https://www.google.com/recaptcha/admin/site/759787672/settings

 https://developers.google.com/digital-asset-links/tools/generator

deep link begin for angular.json if needed
 if needed for deep link in angular.json add 'assetlinks.json' so it goes next after firebase-messaging-sw.js, e.g
   "assets": [
              {
               "glob": " * * / * ",
                "input": "src/assets",
                "output": "assets"
              },
              {
                "glob": "firebase-messaging-sw.js",
                "input": "src",
                "output": "/"
              },
              {
                "glob": "assetlinks.json",
                "input": "src",
                "output": "/"
              }
            ],

deep link end for angular.json

deep link begin for firebase.json add following if needed assetlinks.json

   "rewrites": [
      {
        "source": "/.well-known/assetlinks.json",
        "destination": "/assetlinks.json"
      },
      {
        "source": "**",
        "destination": "/index.html"
      }
    ]

deep link end for firebase.json 

*/
